import { render } from "./LectureViewReportT.vue?vue&type=template&id=31ef4e26&scoped=true"
import script from "./LectureViewReportT.vue?vue&type=script&lang=js"
export * from "./LectureViewReportT.vue?vue&type=script&lang=js"

import "./LectureViewReportT.vue?vue&type=style&index=0&id=31ef4e26&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ef4e26"]])

export default __exports__